module.exports = __webpack_public_path__ + "img/evacmanager_logo.df71dff7.png";